import React, { useEffect } from "react";
import styles from "./index.module.scss";

interface OpenerProps {
    url?: string;
}

export default function Opener({ url }: OpenerProps) {
    useEffect(() => {
        if (url) window.open(url);
    }, [url]);

    return (
        <div className={styles.root}>
            网页已在新窗口打开,{" "}
            <a href={url} target="_blank" rel="noopener noreferrer">
                [重新打开]
            </a>
        </div>
    );
}
